/** Marca do ArchForge (a mesma da landing e do favicon). As barras seguem a cor do texto. */
export default function BrandMark({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg viewBox="0 0 48 48" width={size} height={size} className={className} aria-hidden="true" focusable="false">
      <rect x="6" y="9" width="36" height="9" rx="1.5" fill="currentColor" />
      <rect x="6" y="21" width="9" height="21" rx="1.5" fill="currentColor" />
      <rect x="33" y="21" width="9" height="21" rx="1.5" fill="currentColor" />
      <rect x="19.5" y="5" width="9" height="15" rx="1.5" fill="#7446e6" />
    </svg>
  )
}
